<template>
    <page>
		<module>
            <module-column enable-flex>
                <c-table ref="space_table" code="advert_space_list" @row-click="advertSearchHandle">
                    <c-table-column label="广告位名称" name="space_type" width="120"></c-table-column>
                    <c-table-column label="支持设备" name="support_flag" width="50">
                        <template v-slot="{data}">{{supportFlagName[data.support_flag]}}</template>
                    </c-table-column>
                    <c-table-column label="尺寸" name="size" width="200"></c-table-column>
                </c-table>
            </module-column>

            <module-column enable-flex>
                <m-operate>
                    <c-button power="b_advert_add" color="sys" @click="add()" :disabled="add_advert_btn">新增广告</c-button>
                </m-operate>

                <c-table ref="advert_table" code="advert_list" width="60" :paging="false">
                        <c-table-column label="状态" name="state" width="60">
                            <template v-slot="{data}">
                                <span v-if="data.state==0" style="color:red">{{advertStateName[data.state]}}</span>
                                <span v-if="data.state==1" style="color:darkgreen">{{advertStateName[data.state]}}</span>
                                <span v-if="data.state==2" style="color:#999">{{advertStateName[data.state]}}</span>
                            </template>
                        </c-table-column>
                        <c-table-column
                            label="图片"
                            width="80"
                        >
                          <template v-slot="{data}">
                            <div class="flex-center">
                              <c-image :src="data.file_url" size="50" preview></c-image>
                            </div>
                          </template>
                        </c-table-column>
                        <c-table-column label="生效时间" name="effective_date" width="140"></c-table-column>
                        <c-table-column label="失效时间" name="expire_date" width="140"></c-table-column>
                        <c-table-column label="跳转参数" name="link_params" width="200"></c-table-column>
                        <c-table-column type="button" fixed="right" label="操作" width="120">
                            <template v-slot="{data}">
                                <c-table-button power="b_advert_edit" @click="edit(data)">编辑</c-table-button>
                                <c-table-button power="b_advert_del" @click="del(data)">删除</c-table-button>
                            </template>
                        </c-table-column>
                </c-table>
            </module-column>
		</module>

        <c-dialog ref="editDialog" :title="editState ? '编辑广告' : '新增广告'" width="600" @resolve="submitForm">
                <c-form ref="editForm">
                    <c-form-item type="hidden" name="id"></c-form-item>
                    <c-form-item type="image"  label="广告图" name="file_url"
                        file-word="图片应小于500kb，类型要求 jpg png gif" required oss>
                    </c-form-item>
                    <c-form-item type="link" label="链接参数" name="link_params" :link-type="linkType"></c-form-item>
                    <c-form-item type="datetime" label="生效时间" start-name="effective_date" end-name="expire_date" required></c-form-item>
                </c-form>
        </c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'm_advert',
		data() {
          return {
              advert_space_id:0,
              add_advert_btn:true,
              linkType:'app',
              supportFlagName: {
                  1: 'PC',
                  2: '移动端'
              },
              showTypeName: {
                  1: '自定义',
                  2: '图片轮播',
                  3: '静态图片'
              },
              advertStateName: {
                  0: '未生效',
                  1: '生效中',
                  2: '已失效'
              },
              editState: false
          }
        },
    mounted() {
			this.spaceSearchHandle();
		},
		methods: {
			spaceSearchHandle() {
          this.$refs.space_table.load({
              url: '/advert/space/list'
          });
      },
      advertSearchHandle(row) {
          this.advert_space_id = row.data.advert_space_id;
          this.linkType = row.data.support_flag==1?'pc':'app';
          this.add_advert_btn = false;
          this.$refs.advert_table.load({
              url: '/advert/list',
              data: {
                  advert_space_id: this.advert_space_id
              }
          });
      },
      add(){
          this.$refs.editForm.clear();
          this.$refs.editDialog.open();
      },
      edit(val) {
          this.editState = true;
          this.$refs.editForm.set(val);
          this.$refs.editDialog.open();
      },
      del(val) {
            this.$confirm({
                text: '确定要删除当前广告数据吗？',  // 提示内容,
                buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/advert/remove',
                        data: {id:val.id},
                        loading: true,
                        success: data => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.advert_table.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {},  // 取消按钮回调
            });
      },
      submitForm(stop) {
                    stop();
                    let submitUrl = '/advert/add';
                    if(this.editState){
                        submitUrl = '/advert/edit';
                    }
                    this.$refs.editForm.submit({
                        url: submitUrl,
                        rule: {
                            file_url: [{
                                type: 'empty',
                                word: '请上传广告图'
                            }],
                            effective_date: [{
                                type: 'empty',
                                word: '请选择生效时间'
                            }],
                            expire_date: [{
                                type: 'empty',
                                word: '请选择生效时间'
                            }]
                        },
                        dataFormatter: data => {
                            data.advert_space_id = this.advert_space_id;
                            return data;
                        },
                        success:(data,res) => {
                            this.$message({
                                text: '操作成功',
                                icon: 'success'
                            });
                            this.$refs.advert_table.update();
                            this.$refs.editDialog.close();
                        },
                    });
            }
		}
	}
</script>